<table class="table table-sm align-middle mt-3 mb-0">
  <thead>
    <tr>
      <th scope="col">Display Name</th>
      <th scope="col">Role</th>
      <th scope="col" class="text-end">Default Bonus Pot %</th>
    </tr>
  </thead>
  <tbody>
    @for (row of rows(); track row.userId) {
      <tr>
        <td class="text-nowrap">{{ row.name }}</td>
        <td>{{ roleLabel(row.role) }}</td>
        <td class="text-end">
          <input
            type="number"
            class="form-control form-control-sm text-end"
            step="0.01"
            min="0"
            max="999.99"
            [attr.aria-label]="'Default bonus pot percent for ' + row.name"
            [ngModel]="row.bonusPercent"
            (ngModelChange)="onPercentChange(row.userId, $event)"
          />
        </td>
      </tr>
    }
  </tbody>
</table>
